import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { Observable, BehaviorSubject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})

export class HttpService {

  private messageSource = new BehaviorSubject('keine Query');
  currentMessage = this.messageSource.asObservable();




  constructor(
    private http: HttpClient) {
}


changeMessage(message: string) {
  this.messageSource.next(message);
}


getLanguage(): any {
  return this.http.get( environment.elastic_url_lang)
}


   Search(body: any): Observable<any> {
    const proxyBody = {
      // path: '/_search',
      body: JSON.stringify(body)
    };

        console.log('query = ' + JSON.stringify(body));
        // console.log(environment.elastic_url_search);
        return this.http.post( environment.elastic_url_search, proxyBody, {
          headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      });
    }


   documentBy27(id: any): any {
    const proxyBody = {
      // path: '/_search',
      body: id
    };
        return this.http.post( environment.elastic_url_doctyp27, proxyBody, {
          headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      });

    }

    documentBy28(id: any): any {
      const proxyBody = {
        // path: '/_search',
        body: id
      };
          return this.http.post( environment.elastic_url_doctyp28, proxyBody, {
            headers: new HttpHeaders({
            'Content-Type':  'application/json'
          })
        });
      }



    analyseById(id: any): any {

      const proxyBody = {
        // path: '/_search',
        body: id
      };
      // console.log('body = ' + JSON.stringify(id));
      // console.log(environment.elastic_url_document);
       return this.http.post( environment.elastic_url_analyse, proxyBody, {
        headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    });
      }
}
